export function prescriptionProductError(settings, products, product) {
  const rules = settings?.receita || {};
  const others = products.filter((item) => item.id !== product.id);
  const limit = Number(rules.quantidadeProdutosPorReceita);

  if (!product.id && Number.isInteger(limit) && limit > 0 && others.length >= limit) {
    return `A receita permite no máximo ${limit} produtos.`;
  }

  if (rules.somenteAgrotoxicosMesmaCultura && product.typeProduct === "agrotoxicos") {
    const cultureId = product.infortecnicaReceita?.idCultura;
    if (!cultureId) return "Selecione a cultura do agrotóxico antes de adicioná-lo à receita.";

    if (others.some((item) => item.typeProduct === "agrotoxicos" &&
        String(item.infortecnicaReceita?.idCultura) !== String(cultureId))) {
      return "A receita permite somente agrotóxicos da mesma cultura.";
    }
  }

  return null;
}
